/**
 * Journal moods — must match JOURNAL_MOODS on the backend (database.py and
 * language_learning_backend.py). The analysis suggests one; the learner can
 * pick or change it in the editor.
 */
export const JOURNAL_MOODS = [
  { value: 'happy', label: 'Happy', emoji: '😊' },
  { value: 'excited', label: 'Excited', emoji: '🤩' },
  { value: 'grateful', label: 'Grateful', emoji: '🙏' },
  { value: 'calm', label: 'Calm', emoji: '😌' },
  { value: 'neutral', label: 'Neutral', emoji: '😐' },
  { value: 'tired', label: 'Tired', emoji: '😴' },
  { value: 'stressed', label: 'Stressed', emoji: '😰' },
  { value: 'sad', label: 'Sad', emoji: '😢' },
  { value: 'frustrated', label: 'Frustrated', emoji: '😤' },
];

/** "😊 Happy" for a stored mood value; falls back to the raw value. */
export function moodLabel(value) {
  if (!value) return '';
  const mood = JOURNAL_MOODS.find((m) => m.value === String(value).toLowerCase());
  return mood ? `${mood.emoji} ${mood.label}` : value;
}
